import { render, staticRenderFns } from "./IconApply.vue?vue&type=template&id=72cb7163&"
import script from "./IconApply.vue?vue&type=script&lang=js&"
export * from "./IconApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports